import { cloneElement, forwardRef } from "react";
import "./css/ButtonPrimary.css";
import { useButton, ButtonProps } from "@mui/base";

// COMPONENTS
import { LoadingSpinner2 } from "../Loaders";

// icon
import { IoMdArrowDropdown } from "react-icons/io";
import { HiOutlineSelector } from "react-icons/hi";
import { FaSort } from "react-icons/fa";
import useRenderIcon from "../../hooks/useRenderIcon";

const ButtonPrimary = forwardRef((props, ref) => {
  const {
    name,
    iconStart,
    iconEnd,
    dropDown,
    select,
    bgColor,
    variant = 1,
    size = "normal",
    fullWidth = false,
    width,
    danger = false,
    success = false,
    warning = false,
    edge,
    className = "",
    style = {},
    loading = false,
    disabled = false,
    type = "button",
  } = props;

  const { active, focusVisible, getRootProps } = useButton({
    ...props,
    rootRef: ref,
  });

  const renderIcon = useRenderIcon();

  const spinnerColor = () => {
    if (bgColor) return "var(--neutral-50)";
    if (variant === "border") return "var(--neutral-450)";
    return "var(--blue-500)";
  };

  return (
    <button
      {...getRootProps()}
      type={type}
      disabled={loading || disabled}
      className={`btn-primary 
      variant-${variant}
      size-${size}
      edge-${edge}
      ${success && "success"}
      ${warning && "warning"}
      ${danger && "danger"}
      ${fullWidth && "fullWidth"}
      ${bgColor && "with-bg"}
      ${iconStart && "with-iconStart"}
      ${(iconStart || iconEnd) && "icon"}
      ${className} 
      ${loading && "loading"}
      `}
      style={{
        width: `${width}rem`,
        justifyContent: (fullWidth || width) && "center",
        backgroundColor: bgColor,
        border: `1px solid ${bgColor}`,
        paddingRight: (dropDown || select) && "0.4rem",
        ...style,
      }}
    >
      {loading && (
        <LoadingSpinner2
          variant={1}
          size={1.05}
          color={spinnerColor()}
          thickness={0.12}
          style={{
            position: "absolute",
            inset: 0,
            margin: "auto",
          }}
        />
      )}
      {renderIcon(iconStart, "iconStart")}
      {name && <span>{name}</span>}
      {dropDown && <IoMdArrowDropdown className="icon iconEnd btn-dropDown" />}
      {select && <FaSort className="icon iconEnd btn-select" />}
      {renderIcon(iconEnd, "iconEnd")}
      {props.children}
    </button>
  );
});

export default ButtonPrimary;
